import { render } from "./InternalUserInfoBar.vue?vue&type=template&id=3cef5d98&scoped=true"
import script from "./InternalUserInfoBar.vue?vue&type=script&lang=js"
export * from "./InternalUserInfoBar.vue?vue&type=script&lang=js"

import "./InternalUserInfoBar.vue?vue&type=style&index=0&id=3cef5d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cef5d98"]])

export default __exports__